import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { useLang } from "@/context/LangContext";
import { qrTarget } from "@/lib/config";
import { INSTAGRAM_URL, FACEBOOK_URL, YOUTUBE_URL, WHATSAPP_CATALOG_URL } from "@/lib/config";
import { useSiteMedia } from "@/context/SiteMediaContext";

const Footer = () => {
  const { t } = useLang();
  const { media } = useSiteMedia();

  return (
    <footer data-testid="site-footer" className="bg-charcoal text-bone mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <img
              src={media("logo")}
              alt="Kaós Italian Luxury Cosmetics®"
              className="w-64 max-w-full h-auto invert mix-blend-screen"
            />
            <p className="text-sm text-stone-400 mt-4 max-w-xs leading-relaxed">
              {t("footer.tagline")}
            </p>
            <div className="flex gap-4 mt-8">
              {INSTAGRAM_URL && <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="social-instagram" className="text-stone-400 hover:text-champagne transition-colors">
                <Instagram size={20} strokeWidth={1.5} />
              </a>}
              {FACEBOOK_URL && <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" data-testid="social-facebook" className="text-stone-400 hover:text-champagne transition-colors">
                <Facebook size={20} strokeWidth={1.5} />
              </a>}
              {YOUTUBE_URL && <a href={YOUTUBE_URL} target="_blank" rel="noreferrer" data-testid="social-youtube" className="text-stone-400 hover:text-champagne transition-colors">
                <Youtube size={20} strokeWidth={1.5} />
              </a>}
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-5">{t("footer.shop")}</p>
            <ul className="space-y-3 text-sm text-stone-300">
              <li><Link to="/shop?cat=skincare" className="hover:text-champagne transition-colors">Skincare</Link></li>
              <li><Link to="/shop?cat=profumi" className="hover:text-champagne transition-colors">Profumi</Link></li>
              <li><Link to="/shop?cat=fragranze-ambiente" className="hover:text-champagne transition-colors">Fragranze Ambiente</Link></li>
              <li><a href={WHATSAPP_CATALOG_URL} target="_blank" rel="noreferrer" className="hover:text-champagne transition-colors">Catalogo WhatsApp</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-5">{t("footer.company")}</p>
            <ul className="space-y-3 text-sm text-stone-300">
              <li><Link to="/about" className="hover:text-champagne transition-colors">{t("nav.about")}</Link></li>
              <li><Link to="/reviews" className="hover:text-champagne transition-colors">{t("nav.reviews")}</Link></li>
              <li><Link to="/skin-test" className="hover:text-champagne transition-colors">{t("nav.skinTest")}</Link></li>
              <li><Link to="/reseller" className="hover:text-champagne transition-colors">{t("nav.reseller")}</Link></li>
              <li><Link to="/contact" className="hover:text-champagne transition-colors">{t("nav.contact")}</Link></li>
            </ul>
            <div className="mt-8 flex items-center gap-3" data-testid="footer-qr">
              <div className="bg-white p-2 rounded-sm">
                <QRCodeSVG value={qrTarget()} size={64} bgColor="#ffffff" fgColor="#1C1917" level="M" />
              </div>
              <p className="text-xs text-stone-400 max-w-[130px] leading-relaxed">
                {t("footer.tagline")}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-800 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-3 text-xs text-stone-500">
          <p>© {new Date().getFullYear()} Kaós® Luxury Cosmetics. {t("footer.rights")}</p>
          <p className="uppercase tracking-[0.2em]">Made in Italy</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
